import {
  useHotelsStyles,
  useModuleBEM,
  useTenantHotelAmenitiesIcons,
} from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import type { Amenity } from "@b2bportal/lodging-api";
import clsx from "clsx";
import defaultStyles from "./AmenityIcon.module.scss";

export interface AmenityIconComponentProps
  extends React.SVGAttributes<HTMLOrSVGElement> {
  amenity: Amenity;
  className?: string;
  useCurrentColor?: boolean;
  alt?: string;
}
const COMPONENT_KEY = CoreHotelsComponent.AmenityIcon;

export const AmenityIcon = ({
  amenity,
  className,
  alt,
  ...props
}: AmenityIconComponentProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  const icons = useTenantHotelAmenitiesIcons();
  const IconComponent = icons[amenity];
  return IconComponent ? (
    <IconComponent className={clsx(block, className)} {...props} />
  ) : null;
};
